import {
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ApiModule, Configuration } from '@libs/shared/api';
import { environment } from '@sprint-expert/environments/environment';

export const provideApi = (): Array<Provider | EnvironmentProviders> => {
  return [
    importProvidersFrom(
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath:
              Capacitor.getPlatform() === 'ios'
                ? environment.apiBaseUrl.ios
                : Capacitor.getPlatform() === 'android'
                  ? environment.apiBaseUrl.android
                  : environment.apiBaseUrl.web,
            withCredentials: true,
          })
      )
    ),
  ];
};
